module.exports = __webpack_public_path__ + "img/empty.6549fcaf.png";